import React from 'react';
import { Radio, RadioGroup, FormControl } from '@mui/material';
import { CustomRadio, CustomFormLabel } from './componentsnew';

const InputRadioGroup = ({
  name,
  id = name,
  label,
  value = '',
  onChange,
  options = [],
  row = true,
  ...props
}) => {
  const labelId = `${id}-label`;

  return (
    <FormControl>
      {label && <CustomFormLabel id={labelId}>{label}</CustomFormLabel>}
      {/* {label && <FormLabel id={labelId}>{label}</FormLabel>} */}
      <RadioGroup
        id={id}
        aria-labelledby={label ? labelId : undefined}
        aria-label={label ? undefined : id}
        name={name}
        value={value}
        onChange={onChange || (() => {})}
        row={row}
        {...props}
      >
        {options.map((option) => (
          <CustomRadio
            key={option.value}
            control={option.control || <Radio size='small' />}
            value={option.value}
            label={option.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default InputRadioGroup;
